import React, { useMemo, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HomeDashboardLayout from "../HomeDashboardLayout";
import MyWalletSidebar from "../MyWalletSidebar";
import "../../dashboard/Dashboard.css";
import "../HomeDashboard.css";
import "../questionBank/QuestionBankList.css";
import HeaderProfileSection from "../HeaderProfileSection";
import { buildDoubtFlowState } from './doubtFlowState';
import { DOUBT_ROUTES } from './doubtRoutes';
import { attachmentUrl, buildDoubtDraft } from './doubtDraftState';
import { compressFiles } from "../../utils/imageCompressor";
import "./Doubt.css";
import "./AskYourDoubt.css";
import "./DoubtFlowLayout.css";

import galleryIcon from "../../assets/images/galleryIcon.png";
import cameraIcon from "../../assets/images/camera.png";

const AskDoubts = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const flow = useMemo(() => buildDoubtFlowState(location.state), [location.state]);
  const [draft, setDraft] = useState(() => buildDoubtDraft(location.state?.doubtDraft || location.state?.selectedDoubt));

  const addFiles = async (files) => {
    const compressedFiles = await compressFiles(files);
    setDraft((current) => ({ ...current, newAttachments: [...current.newAttachments, ...compressedFiles] }));
  };
  const removeNewFile = (index) => setDraft((current) => ({ ...current, newAttachments: current.newAttachments.filter((_, fileIndex) => fileIndex !== index) }));
  const removeExistingFile = (attachment, index) => setDraft((current) => ({ ...current, existingAttachments: current.existingAttachments.filter((_, fileIndex) => fileIndex !== index), deleteAttachmentIds: [...current.deleteAttachmentIds, Number(attachment?.attachment_id || attachment?.id || 0)].filter(Boolean) }));
  
  const next = () => {
    if (!draft.description.trim()) return;
    navigate(DOUBT_ROUTES.categories, { state: { ...flow, doubtDraft: draft } });
  };

  return (
    <>
      <style>{`
      .homeDashboard-wrapper .main-content{
         padding-bottom: 20px;
         overflow-x: hidden !important;
       }
      .qbl-panel {
          min-height: calc(100vh - 20px);
      }
     @media (min-width: 1200px) and (max-width: 1400px) {
      .qbl-panel {
         padding: 30px 25px!important;
       }
      }
    @media (max-width: 767px) {
     .qbl-panel {
        padding: 15px !important;
      }
    .ask-doubt-modal__body {
       padding: 16px 0px 0px;
    }
  }


      }
     `}</style>
      <HomeDashboardLayout showHeader={false} variant="doubt-flow-layout">
        <div className="qbl-page qbankList-page askDoubt p-0">
          <div className="start-quiz qbl-main qbl-panel">
            <div className="hideProfile-page">
              {/* Page header */}
              <div className="categories-page-header mb-0">
                <div>
                  <button type="button" className="categories-back-button" onClick={() => navigate(-1)} aria-label="Go back">
                    <i className="bi bi-chevron-left"></i>
                  </button>
                </div>

                <div>
                  <h4 className="d-flex d-sm-none categories-page-title"></h4>
                </div>

                <div>
                  <HeaderProfileSection />
                </div>
              </div>
            </div>

            {/* Page Title Section */}
            <div className="">
              <h1 className="qb-title">
                {draft.doubtId ? 'Edit' : 'Ask'} <span>Your Doubts</span>
              </h1>

              <p className="qb-sub">Practice more, score higher</p>
            </div>

            {/* Ask Doubt Body */}
            <div className="ask-doubt-modal__body">
              <input
                type="text"
                className="ask-doubt-modal__title"
                placeholder="Title"
                value={draft.title}
                onChange={(event) => setDraft((current) => ({ ...current, title: event.target.value }))}
              />

              <textarea
                className="ask-doubt-modal__textarea"
                placeholder="Write Doubt"
                value={draft.description}
                onChange={(event) => setDraft((current) => ({ ...current, description: event.target.value }))}
              />
            </div>

            {/* =========================
                IMAGE PREVIEW + FOOTER
            ========================== */}
            <div>
              <div className="result-bottom-nav ask-result-nav">
                {/* Uploaded Images */}
                <div className="ask-doubt-images">
                  {draft.existingAttachments.map((attachment, index) => (
                    <div className="ask-doubt-image-item" key={`existing-${index}`}>
                      <img src={attachmentUrl(attachment)} alt="Existing attachment" className="ask-doubt-image" />
                      <button type="button" className="ask-doubt-image-remove" onClick={() => removeExistingFile(attachment, index)} aria-label="Remove image">×</button>
                    </div>
                  ))}
                  {draft.newAttachments.map((file, index) => (
                    <div className="ask-doubt-image-item" key={`${file.name}-${index}`}>
                      <img src={URL.createObjectURL(file)} alt="New attachment" className="ask-doubt-image" />
                      <button type="button" className="ask-doubt-image-remove" onClick={() => removeNewFile(index)} aria-label="Remove image">×</button>
                    </div>
                  ))}
                </div>

                {/* Footer */}
                <div className="ask-doubt-modal__footer-icons">
                  <div className="ask-doubt-modal__footer-icon">
                    {/* Gallery */}
                    <input
                      type="file"
                      id="doubt-gallery-input"
                      accept="image/*"
                      multiple
                      onChange={(event) => addFiles(event.target.files)}
                      hidden
                    />

                    <label
                      htmlFor="doubt-gallery-input"
                      className="ask-doubt-modal__icon-button"
                    >
                      <img src={galleryIcon} alt="" />
                    </label>

                    {/* Camera */}
                    <input
                      type="file"
                      id="doubt-camera-input"
                      accept="image/*"
                      capture="environment"
                      onChange={(event) => addFiles(event.target.files)}
                      hidden
                    />

                    <label
                      htmlFor="doubt-camera-input"
                      className="ask-doubt-modal__icon-button"
                    >
                      <img src={cameraIcon} alt="" />
                    </label>
                  </div>

                  {/* Next */}
                  <button type="button" className="ask-doubt-modal__next mw-100" disabled={!draft.description.trim()} onClick={next}>
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <MyWalletSidebar withTopOffset={false} />
      </HomeDashboardLayout>
    </>
  );
};

export default AskDoubts;
